
// vue
import { defineComponent } from 'vue';

// shared
import { shared, generalProps } from '../shared';

// types
import type { Props, Context } from '../types';

// naive-ui
import {
    NCard,
    NSpin,
    NPopover,
    NIcon,
    NButton,
} from 'naive-ui';

import { QuestionCircle20Filled } from '@vicons/fluent';

export default defineComponent({
    name: 'rb-reset-fix-order-desktop',
    props: generalProps,
    components: {
        NCard,
        NSpin,
        NPopover,
        NIcon,
        NButton,
        QuestionCircle20Filled,
    },
    setup(props, context: Context) {
        return {
            ...shared(props as Readonly<Props>, context),
        };
    },
});
